var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSmallPdf = function SvgSmallPdf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#292D32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M15 2.5H9c-5 0-6 2.06-6 6.18v7.17c0 4.7 1.67 5.96 5 6.15h8c3.33-.18 5-1.45 5-6.15V8.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#292D32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m21 8.5-6-6v3q0 3 3 3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#292D32",
    d: "M8.796 14.609c-.169.119-.345.203-.527.24l-.01-.049q-.356.073-1.02.072zm0 0q.26-.183.427-.495.166-.323.166-.774 0-.594-.291-.977a1.34 1.34 0 0 0-.729-.497 2.4 2.4 0 0 0-.438-.056 13 13 0 0 0-.74-.017H5.868a.3.3 0 0 0-.3.3v4.36a.3.3 0 0 0 .3.3h.483a.3.3 0 0 0 .3-.3v-1.531zm-.623-.91c-.07.1-.161.173-.285.219a1.2 1.2 0 0 1-.279.053q-.19.02-.48.02h-.487v-1.276h.424q.53 0 .696.03h.001a.62.62 0 0 1 .365.199.58.58 0 0 1 .143.404v.001a.56.56 0 0 1-.098.35"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#292D32",
    strokeWidth: 0.1,
    d: "M8.796 14.609c-.169.119-.345.203-.527.24m.527-.24-1.556.263q.664 0 1.018-.072l.01.05m.528-.241q.26-.183.427-.495.166-.323.166-.774 0-.594-.291-.977a1.34 1.34 0 0 0-.729-.497 2.4 2.4 0 0 0-.438-.056 13 13 0 0 0-.74-.017H5.868a.3.3 0 0 0-.3.3v4.36a.3.3 0 0 0 .3.3h.483a.3.3 0 0 0 .3-.3v-1.531zm-.527.24Zm-.096-1.15c-.07.1-.161.173-.285.219a1.2 1.2 0 0 1-.279.053q-.19.02-.48.02h-.487v-1.276h.424q.53 0 .696.03h.001a.62.62 0 0 1 .365.199.58.58 0 0 1 .143.404v.001a.56.56 0 0 1-.098.35Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#292D32",
    stroke: "#292D32",
    strokeWidth: 0.1,
    d: "M14.998 16.449a.3.3 0 0 0 .3.3h.483a.3.3 0 0 0 .3-.3v-1.764h1.728a.3.3 0 0 0 .3-.3v-.322a.3.3 0 0 0-.3-.3H16.08v-1.048h2.05a.3.3 0 0 0 .3-.3v-.322a.3.3 0 0 0-.3-.3h-2.833a.3.3 0 0 0-.3.3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#292D32",
    d: "M11.864 16.8H10.76l.007-.923h1.097q.341 0 .578-.164a1 1 0 0 0 .362-.489q.127-.329.127-.806v-.216q0-.36-.072-.629a1.25 1.25 0 0 0-.205-.454.86.86 0 0 0-.342-.277 1.1 1.1 0 0 0-.465-.093H10.74v-.926h1.107q.506 0 .926.175.425.171.732.492.311.317.478.755.171.434.171.964v.209q0 .526-.17.963-.168.438-.476.756a2.1 2.1 0 0 1-.728.492q-.417.17-.916.17m-.417-4.977V16.8h-1.2v-4.977z"
  })));
};
export default SvgSmallPdf;